<template>
  <div>
  <div class="realize_wrap">
    <div class="realize_img">
      <div class="img_tit">{{ $t('understandRedC.title') }}</div>
    </div>
    <div class="show_box_index">
      <div class="product_shows_wrap">
        <div class="table_wrap hidden-xs-only">
          <el-form label-position="left" label-width="70px" class="table_form">
            <p>{{ $t('understandRedC.desc') }}</p>
          </el-form>
        </div>
        <div class="table_wrap2 hidden-xs-only">
          <el-form label-position="left" label-width="70px" class="table_form">
            <p>{{ $t('understandRedC.features') }}</p>
          </el-form>
        </div>
        <div class="table_wrap_mobile hidden-sm-and-up">
          <el-form label-position="left" label-width="70px" class="table_form">
            <p>{{ $t('understandRedC.desc') }}</p>
          </el-form>
        </div>
        <div class="table_wrap_mobile hidden-sm-and-up">
          <el-form label-position="left" label-width="70px" class="table_form">
            <p>{{ $t('understandRedC.features') }}</p>
          </el-form>
        </div>
      </div>
    </div>
    <CallMe />
    </div>
    <MobileCallme></MobileCallme>
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
export default {
  data() {
    return {
      showModal: false,
    }
  },
  methods: {
    toRedc() {
      window.open('https://redc.carbon-tc.com/', '_blank')
    },
  },
  components: {
    CallMe,
    MobileCallme,
  },
  created(){
  },
  watch: {
  },
}
</script>

<style lang="scss" scoped>
.realize_wrap {
  min-height: 85vh;
  background-color: #f6f9fd;
  .realize_img {
    width: 100%;
    height: 700px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../../assets/img/hly/new/关于我们/关于我们.jpg') 0 0 no-repeat;
    background-size: cover;
    background-position: center;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    .learn-more {
      background: #f29c11;
      color: #fff;
      border: none;
      padding: 0.5rem 1.5rem;
      border-radius: 5px;
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, 150%);
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
        margin-top: -1.5rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .realize_nav_wrap {
    width: 100%;
    height: 60px;
    @media screen and (max-width: 768px) {
      height: 50px;
    }
    .realize_nav {
      height: 100%;
      display: flex;
      align-items: center;
      .active {
        font-weight: bold;
        color: #000;
      }
      .realize_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .nav_top {
          font-size: 18px;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
        .nav_bottom {
          width: 30%;
          height: 4px;
          margin-top: 10px;
          background: #2091d3;
        }
      }
    }
  }
  .product_shows_wrap {
    width: 100%;
    background: url('../../assets/img/introBg.40f79db.png') 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: -7px;
    box-sizing: border-box;
    height: 700px;
    position: relative;
    @media screen and (max-width: 768px) {
      background: #f4f9fc;
      height: auto;
    }
    .table_wrap {
      position: absolute;
      top: 33%;
      left: 20%;
      width: 600px;
      .table_form {
        .table_form_item {
          font-weight: bold;
        }
        p{
          font-size: 20px;
        }
      }
    }
    .table_wrap2{
      position: absolute;
      top: 33%;
      right: 5%;
      width: 600px;
      .table_form {
        .table_form_item {
          font-weight: bold;
        }
        p{
          font-size: 20px;
        }
      }
    }
    .table_wrap_mobile {
      padding: 1rem;
      font-size: 0.8rem;
      p {
        font-size: 0.9rem;
      }
      .table_form {
        .table_form_item {
          font-weight: bold;
          margin-top: 1rem;
          font-size: 0.85rem;
          span {
            color: #000;
            font-size: 0.9rem;
            padding-right: 30px;
          }
        }
      }
    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;

    .advantage_wrap {
      width: 70%;
      display: flex;
      margin-top: 70px;
      justify-content: center;
      flex-wrap: wrap;

      @media screen and (max-width: 1024px) {
        width: 90%;
      }

      @media screen and (max-width: 768px) {
        width: 90%;
      }

      .advantage_item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // align-items: center;
        // text-align: center;
        background: #fff;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 30px 20px 40px;
        margin: 15px;
        width: 30%;
        min-height: 250px;
        // border: 1px solid #2091d3;
        padding: 20px;
        position: relative;
        border-radius: 12px;

        border: 2px dashed #f29c11;

        @media screen and (max-width: 768px) {
          width: 45%;
          height: auto;
          padding: 25px;
          margin: 10px;
        }

        @media screen and (max-width: 480px) {
          width: 100%;
          margin: 10px 0;
          padding: 30px;
        }

        .item_top {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 60px;

          .icon {
            i {
              color: #2091d3;
              font-size: 26px;
              padding-right: 10px;

              @media screen and (max-width: 480px) {
                font-size: 28px; // 提高图标大小
              }
            }
          }

          .tit {
            font-size: 20px;
            font-weight: bold;
            color: #1c1c1c;
            text-align: center;

            @media screen and (max-width: 768px) {
              font-size: 22px; // 增加标题大小
            }
          }
        }

        .item_desc {
          font-size: 16px;
          color: #646464;
          line-height: 1.8;
          list-style: disc;
          padding-left: 20px; // 让小圆点有合适的缩进
          min-height: 80px;

          @media screen and (max-width: 768px) {
            font-size: 18px; // 增加描述字体
          }
        }
      }
    }
  }


  .china_map {
    width: 70%;
    margin: 50px auto;
    img {
      width: 100%;
    }
  }
  .timeline_wrap {
    width: 70%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .timeline_card {
      h4 {
        font-size: 24px;
        @media screen and (max-width: 768px) {
          font-size: 18px;
        }
      }
      .timeline_time{
        font-size: 12PX;
      }
      img {
        width: 30%;
        margin-top: 20px;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
      }
    }
  }
  .three_box {
    width: 70%;
    margin: 0 auto;
    height: 200px;
    text-align: center;
    background: url('../../assets/img/ryzz.bc140e4.jpg') 0 0 no-repeat;
    background-size: cover;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    h1 {
      font-size: 40px;
      line-height: 200px;
      color: #fff;
    }
  }
  .three_box_card {
    width: 70%;
    margin: 30px auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    .out_card {
      flex-wrap: wrap;
      .card_item {
        @media screen and (max-width: 768px) {
          margin-top: 10px;
        }
        &:nth-child(n + 4) {
          margin-top: 10px;
        }
        img {
          padding-top: 30px;
          width: 100%;
        }
      }
    }
  }
  .four_wrap {
    width: 70%;
    margin: 0 auto;
    background: url('../../assets/img/58.e28b1c0.png') 0 0 no-repeat;
    background-size: cover;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 150px;
    }
    .out_card {
      width: 100%;
      flex-wrap: wrap;
      .card_item {
        &:nth-child(n + 4) {
          margin-top: 10px;
        }
        .card_content {
          display: flex;
          flex-direction: column;
          text-align: center;
          width: 100%;
          img {
            padding-top: 30px;
            width: 30%;
            @media screen and (max-width: 768px) {
              width: 50%;
            }
          }
        }
      }
    }
  }
  .four_card_spa {
    width: 70%;
    margin: 30px auto;
    .out_card {
      .card_item {
        h1 {
          font-size: 30px;
          margin-top: 10px;
        }
        img {
          margin-top: 30px;
          width: 5%;
        }
        p {
          font-size: 12px;
          margin-top: 10px;
        }
        .card_bg {
          width: 30px;
          height: 5px;
          background: #13519f;
        }
      }
    }
  }
}
.production_title_wrap {
  width: 100%;
  margin-top: 50px;
  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }
  .production_inner {
    display: flex;
    justify-content: center;
    .inner_left {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30%;
      }
    }
    .inner_center {
      // width: 400px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 2.2;
      }
      .production_title {
        font-size: 40px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
      .production_desc {
        font-size: 16px;
        color: #787878;
        margin-top: 10px;
        @media screen and (max-width: 768px) {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
    .inner_right {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      @media screen and (max-width: 768px) {
        flex: 1;
      }
      img {
        width: 30%;
      }
    }
  }
}
/* 新增 - 播放按钮 */
.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  background-color: orange;
  color: #000;
  font-size: 2rem;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; /* 点击事件透传给父元素 */
}
</style>